/**
 * Calculate the effective form scope based on the current form context.
 * When formScope is 'military' and civilian category is selected, treat it as 'work'.
 * Otherwise, use the derived form scope.
 *
 * @param {string} formScope - The base form scope ('work', 'military', or 'education')
 * @param {string} experienceCategory - The selected experience category ('civilian' or 'military')
 * @param {string} derivedFormScope - The derived form scope based on experience type
 * @returns {string} The effective form scope to use
 */
export const getEffectiveFormScope = (formScope, experienceCategory, derivedFormScope) => {
  if (formScope === 'military' && experienceCategory === 'military') return 'military';
  return formScope === 'military' && experienceCategory === 'civilian' ? 'work' : derivedFormScope;
};
